// extracted by mini-css-extract-plugin
export default {"wrapper":"y4-z","play":"z4-z"};